import {Button, Grid, Tooltip} from '@material-ui/core'
import FilterListIcon from '@material-ui/icons/FilterList'
import ReportsPopover from 'modules/reports/components/Popover'
import useCore from 'modules/reports/hooks/core'
import React from 'react'
import useStyles from './ReportsFilters.styles'

type Props = {
  children: React.ReactNode
}

function ReportsFilters(props: Props) {
  const {p, pt} = useCore('reports', 'components', 'Filters')
  const classes = useStyles()

  return (
    <ReportsPopover
      trigger={({open, opened, ariaProps}) => {
        return (
          <Tooltip title={pt('button-text')}>
            <Button
              className={`${classes.button} ${
                opened ? classes.openedButton : classes.closedButton
              }`}
              onClick={open}
              variant={opened ? 'contained' : undefined}
              color={opened ? 'primary' : undefined}
              aria-label={pt('button-text')}
              {...ariaProps}
              data-testid={p('trigger')}
            >
              <FilterListIcon />{' '}
              {opened && <span className={classes.buttonText}>{pt('button-text')}</span>}
            </Button>
          </Tooltip>
        )
      }}
      data-testid={p('popover')}
    >
      <Grid container className={classes.grid} spacing={8} direction="row">
        {props.children}
      </Grid>
    </ReportsPopover>
  )
}

export default ReportsFilters
